import { useState } from "react";
import styles from "./mortgageRepayment.module.css";
import MortgageRepaymentResult from "./mortgageRepaymentResult";
import CurrencyInput from "react-currency-input-field";

const MortgageRepayment = () => {
  const [loan, setLoan] = useState(0);
  const [extra, setExtra] = useState(0);
  const [year, setYear] = useState(30);
  const [rate, setRate] = useState(5.49);

  const years = Array.from({ length: 30 }, (_, index) => index + 1);

  const onMRChange = () => {
    setTimeout(() => {
      const textra = document.getElementById("mrExtraPay").value;
      const tyear = document.getElementById("mrYears").value;
      const trate = document.getElementById("mrRate").value;
      setExtra(textra);
      setYear(tyear);
      setRate(trate);
    }, 1000);
  };

  const onLoanChange = (value) => {
    setLoan(value);
  };

  return (
    <>
      <div className={`row g-6 ${styles.main_wrapper}`}>
        <div className={`row g-3 ${styles.data_wrapper}`}>
          <div className="col-m-6">
            <label className={`form-label ${styles.label}`}>Loan Amount</label>
            <div className={styles.flex_wrapper}>
              <span className={styles.labeld}>$</span>
              <CurrencyInput
                className={`form-control ${styles.money_input}`}
                id="mrloanAmmount"
                name="input-name"
                defaultValue={loan}
                decimalsLimit={2}
                onValueChange={(value, name, values) => onLoanChange(value)}
              />
            </div>
          </div>
          <div className="col-m-6">
            <label className={`form-label ${styles.label}`}>
              Extra monthly payments
            </label>
            <div className={styles.flex_wrapper}>
              <span className={styles.labeld}>$</span>
              <input
                id="mrExtraPay"
                type="number"
                min={0}
                step={1}
                onChange={onMRChange}
                className={`form-control ${styles.money_input}`}
                defaultValue={extra}
              ></input>
            </div>
          </div>
          <div className="col-m-6">
            <label className={`form-label ${styles.label}`}>Loan Term</label>
            <select id="mrYears" onChange={onMRChange} className="form-select">
              {years
                .sort((a, b) => b - a)
                .map((value, index) => (
                  <option key={value} value={value}>
                    {value + ` years`}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-m-6">
            <label className={`form-label ${styles.label}`}>Current Rate</label>
            <div className={styles.flex_wrapper}>
              <input
                id="mrRate"
                type="number"
                step={0.01}
                min={0}
                onChange={onMRChange}
                className={`form-control ${styles.rate_holder}`}
                defaultValue={rate}
              ></input>
              <span className={styles.labeld3}>%</span>
            </div>
          </div>
        </div>
        <div className={`row g-3 ${styles.data_wrapper}`}>
          <MortgageRepaymentResult
            loan={loan}
            extra={extra}
            year={year}
            rate={rate}
          />
        </div>
      </div>
    </>
  );
};

export default MortgageRepayment;
